// extracted by mini-css-extract-plugin
export default {"iframe":"style_iframe__SjKhb","error":"style_error__BpifB"};